import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const PendingTabSkeleton: React.FC = () => (
  <div className="space-y-2 py-2">
    {Array.from({ length: 6 }).map((_, i) => <Skeleton key={i} className="h-10 w-full" />)}
  </div>
)
export default PendingTabSkeleton
